/** Thrown when shared dialog shell AWAIT confirm exceeds the configured timeout. */
export class SharedDialogAwaitTimeoutError extends Error {
    constructor(
        /** Effective timeout in ms that was applied. */
        readonly timeoutMs: number,
        message: string
    ) {
        super(message);
        Object.setPrototypeOf(this, SharedDialogAwaitTimeoutError.prototype);
    }
}
